module.exports = __webpack_public_path__ + "img/Gallery_3_15.1433d6e4.jpeg";